import type { TicketSource } from '@/lib/services/helpdeskDashboardService'
import ReportBarChart from '@/components/reports/ReportBarChart'

type Props = {
  source: TicketSource
  loading?: boolean
}

export default function TicketSourceCard({ source, loading }: Props) {
  const data = (source.sources ?? []).map((s) => ({
    label: s.name,
    count: s.value,
    color: s.color || undefined,
  }))

  const periodLabel = source.period?.replace(/_/g, ' ') ?? 'period'

  return (
    <ReportBarChart
      title="Ticket source"
      subtitle={`${(source.total_active ?? 0).toLocaleString()} active · ${periodLabel}`}
      data={data}
      loading={loading}
      height={220}
      emptyMessage="No ticket source breakdown for this period."
    />
  )
}
